import { Component, OnChanges, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { VariablesService } from 'src/app/shared/services';
import { about_ketto, how_it_works, how_it_works_k_cart, how_non_medical } from './how-works.model';

@Component({
  selector: 'app-about-domain',
  standalone: true,
  imports: [CommonModule, SharedModule],
  templateUrl: './about-domain.component.html',
  styleUrls: ['./about-domain.component.scss']
})
export class AboutDomainComponent implements OnInit, OnChanges {

  howItWorksArray: any[] = [];
  aboutContent = about_ketto;
  howItWorksContent = {
    patient: '',
    hospital: '',
    beneficiary: '',
    manager: ''
  };

  constructor(
    public vars: VariablesService
  ) {}

  ngOnInit(): void {
    this.setFooterContent();
  }

  ngOnChanges() {
    this.setFooterContent();
  }

  setFooterContent() {
    let beneficiary_name = this.vars.fundraiser?.beneficiary?.full_name || this.vars.basicInfo?.beneficiary_name || (this.vars.fundraiser?.non_medical ? 'NGO Partner' : 'Patient')
    this.howItWorksContent = {
      patient: beneficiary_name,
      hospital: this.vars.fundraiser?.hospital?.info_1 || '',
      beneficiary: beneficiary_name,
      manager: this.vars.fundraiser?.manager?.entity?.full_name || 'Fundraiser Manager',
    };
    if (this.vars.showKCart) {
      this.howItWorksArray = how_it_works_k_cart();
    } else {
      this.howItWorksArray = this.vars.fundraiser?.non_medical ? how_non_medical(this.howItWorksContent) : how_it_works(this.howItWorksContent);
    }
  }


}
